import { useEffect } from 'react';

/**
 * Hook to set the page title dynamically
 * @param title - The title to set for the page
 * @param prefix - Optional prefix (defaults to "Digger - ")
 */
export const usePageTitle = (title: string, prefix: string = "Digger - ") => {
	useEffect(() => {
		if (title)
			document.title = `${prefix}${title}`;
		
		// Cleanup: reset to default title when component unmounts
		return () => {
			document.title = "Digger";
		};
	}, [title, prefix]);
};
